var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "operational-table" },
    [
      _c("ag-grid-vue", {
        staticClass: "ag-theme-alpine",
        staticStyle: { width: "100%", height: "100%" },
        attrs: { "grid-options": _vm.gridOptions },
        on: { "grid-ready": _vm.onGridReady },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }